'use strict';exports.__esModule = true;var _moment = require('moment');var _moment2 = _interopRequireDefault(_moment);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var getDefaultChartData = function getDefaultChartData() {
  var start = (0, _moment2.default)().startOf('day').subtract(10, 'days');

  var events = Array.from({ length: 11 }, function () {return {
      action: 'view',
      date: start.add(1, 'days').toISOString(),
      count: 0 };});


  return [{ events: events }];
};exports.default =

getDefaultChartData;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/getDefaultChartData.js
// module id = 3005
// module chunks = 0